import { render } from "./catList.vue?vue&type=template&id=57bdcd92&scoped=true"
import script from "./catList.vue?vue&type=script&lang=js"
export * from "./catList.vue?vue&type=script&lang=js"

import "./catList.vue?vue&type=style&index=0&id=57bdcd92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57bdcd92"

export default script